import React, { Fragment, useEffect, useRef, useState, } from "react"
import { useTranslation } from "react-i18next"

import { getSnapboxWallet, snapboxOtpConfirm } from "services"
import { CountDownTimer, Spinner } from "components"
import PinCodeInput from "./PinCodeInput"
import classes from "./TnSnapboxOtpStep2.module.scss"

const initialFormErrorState = {
  confirmCode: ""
}

const TnSnapboxOtpStep2 = props => {
  const {
    form,
    setForm,
    setStep,
    setSnapboxBalance,
    setNeedOtp,
    setOpenOtpModal,
    selectedBranch
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [formErrors, setFormErrors] = useState(initialFormErrorState)

  const unmount = useRef(false)

  const getRequestBody = (pincode) => {
    const data = {
      branchId: selectedBranch._id,
      confirmCode: pincode,
      mobilePhone: form.mobilePhone
    }

    return data
  }

  const handleGoBack = () => {
    setStep(1)

    setForm(prev => ({ ...prev, confirmCode: "" }))
  }

  const handleSubmit = async pincode => {
    setSending(true)

    try {
      const data = getRequestBody(pincode)

      await snapboxOtpConfirm(data)

      const { currentBalance } =
        await getSnapboxWallet(selectedBranch._id)

      if (unmount.current) return

      setSnapboxBalance(currentBalance / 10 | 0)

      setNeedOtp(false)

      setOpenOtpModal(false)
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setSending(false)

      setForm(prev => ({
        ...prev,
        confirmCode: ""
      }))

      setFormErrors(prev => ({
        ...prev,
        confirmCode: t("عملیات_انجام_نشد")
      }))
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <p className={classes["title"]}>
        <span>{t("یک_کد_به_شماره")} </span>{" "}
        <b>{form.mobilePhone}</b>{" "}
        <span>{t("ارسال_شد")}</span>{" "}
        <span
          className={classes["go-back"]}
          onClick={handleGoBack}
        >
          {t("ویرایش_موبایل")}
        </span>
      </p>

      <div className={classes["timer"]}>
        <CountDownTimer
          zeroPads={{ seconds: true }}
          show={{ minutes: true, seconds: true }}
          onTimeout={() => setStep(1)}
          initialTime={5 * 60}
        />
      </div>

      <PinCodeInput
        onFinished={handleSubmit}
        value={form.confirmCode}
        onChange={value =>
          setForm(prev => ({
            ...prev,
            confirmCode: value
          }))
        }
      />
      {
        !!formErrors.confirmCode &&
        !sending &&
        <div className={classes["error"]}>
          {formErrors.confirmCode}
        </div>
      }
      {
        sending &&
        <div className={classes["loading"]}>
          <Spinner />
        </div>
      }
    </Fragment>
  )
}

export default TnSnapboxOtpStep2